module.exports = __webpack_public_path__ + "static/img/product_img_08.70d8eaa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product_img_08.jpg
// module id = 8O99
// module chunks = 0